export interface Menu {
    visible?: boolean;
    name?: string;
    routerPath?: string[];
    icon?: string;
    callToAction?: CallableFunction;
    isActive?: boolean;
    grouping?: string | null;
    submenu?: Menu[];
    tab?: string;
    operationHistory?: string;
    externalLink?: string;
    reference?: string;
}

export interface MenuList {
    app: MenuResponse[];
    desktop: MenuResponse[];
}

export interface MenuResponse {
    id: string;
    name: string;
    icon: string;
    tab: string;
    routerPath: string;
    visible: boolean;
    visibleCondition: string;
    operationHistory: string;
    app: boolean;
    submenu: MenuResponse[];
    grouping: string;
    externalLink: string;
    reference: string | null;
}

export class MenuFactory {
    static create(menuResponse: MenuResponse): Menu {
        return {
            visible: menuResponse.visible,
            name: menuResponse.name,
            routerPath: menuResponse.routerPath ? [menuResponse.routerPath] : null,
            icon: menuResponse.icon,
            isActive: false,
            grouping: menuResponse.grouping,
            externalLink: menuResponse.externalLink,
            submenu: [],
            tab: menuResponse.tab,
            operationHistory: menuResponse.operationHistory,
            reference: menuResponse.reference
        };
    }
}
